<template>
  <div class="pic-zoom" @mouseenter="onEnter" @mouseleave="onLeave" @mousemove="onMove">
    <img :src="url" ref="img" class="pic-zoom__img" />
    <div v-show="show" class="pic-zoom__pane" :style="zoomStyle"></div>
  </div>
</template>

<script>
export default {
  name: 'PicZoom',
  props: {
    url: { type: String, required: true },
    scale: { type: Number, default: 2 }
  },
  data() {
    return {
      show: false,
      x: 50,
      y: 50,
      rect: { width: 0, height: 0 }
    };
  },
  computed: {
    zoomStyle() {
      const w = Math.max(this.rect.width, 1) * this.scale;
      const h = Math.max(this.rect.height, 1) * this.scale;
      return {
        backgroundImage: `url(${this.url})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: `${w}px ${h}px`,
        backgroundPosition: `${this.x}% ${this.y}%`
      };
    }
  },
  methods: {
    onEnter() {
      this.measure();
      this.show = true;
    },
    onLeave() {
      this.show = false;
    },
    onMove(e) {
      this.measure();
      const r = this.$refs.img.getBoundingClientRect();
      const cx = Math.min(Math.max(e.clientX - r.left, 0), r.width);
      const cy = Math.min(Math.max(e.clientY - r.top, 0), r.height);
      this.x = (cx / r.width) * 100;
      this.y = (cy / r.height) * 100;
    },
    measure() {
      const r = this.$refs.img && this.$refs.img.getBoundingClientRect();
      if (r) this.rect = { width: r.width, height: r.height };
    }
  }
};
</script>

<style scoped>
.pic-zoom { position: relative; display: inline-block; }
.pic-zoom__img { display: block; max-width: 100%; }
.pic-zoom__pane { position: absolute; top: 0; left: 100%; margin-left: 16px; width: 360px; height: 360px; border: 1px solid #eee; background-color: #fff; box-shadow: 0 2px 8px rgba(0,0,0,0.08); }
</style>